import { Spacing8 } from 'autogen/design-tokens/tokens';
import { ProductInformationViewModel } from 'autogen/swagger/all';
import { TagSplash } from 'components/shared/Splash';
import { ISplash } from 'components/shared/Splash/shared/types';
import React from 'react';
import styled from 'styled-components';

const SplashContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${Spacing8};
`;

export default function SplashTagLines({
    splashes,
    size = 'md',
    ...restProps
}: {
    splashes: ProductInformationViewModel['splashes'];
    size?: ISplash['size'];
}) {
    const { primary, secondary } = splashes;

    if (primary || secondary) {
        return (
            <SplashContainer {...restProps}>
                {primary && <TagSplash {...{ size, columnsOnMobile: false, ...primary }} />}
                {secondary && <TagSplash {...{ size, columnsOnMobile: false, ...secondary }} />}
            </SplashContainer>
        );
    }

    return null;
}
